import React from "react";
import { Form, Input, Select, Button } from "antd";

const { Option } = Select;

const QuestionForm = ({
  form,
  subjects = [],
  initialValues = {},
  onSubmit,
  submitText = "Save Question",
  loading = false,
}) => {
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={onSubmit}
    >
      {/* Subject */}
      <Form.Item
        name="subjectId"
        label="Subject"
        rules={[{ required: true, message: "Please select a subject" }]}
      >
        <Select placeholder="Select subject">
          {subjects.map(subject => (
            <Option key={subject.id} value={subject.id}>
              {subject.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* Class Level */}
      <Form.Item
        name="classLevel"
        label="Class Level"
        rules={[{ required: true, message: "Please select class level" }]}
      >
        <Select placeholder="Select class level">
          <Option value="Form I">Form I</Option>
          <Option value="Form II">Form II</Option>
          <Option value="Form III">Form III</Option>
          <Option value="Form IV">Form IV</Option>
        </Select>
      </Form.Item>

      {/* Exam Set */}
      <Form.Item
        name="examSet"
        label="Exam Set"
        rules={[{ required: true, message: "Please enter exam set" }]}
      >
        <Input placeholder="e.g. Midterm 1, Final Exam" />
      </Form.Item>

      {/* Section */}
      <Form.Item
        name="section"
        label="Section"
        rules={[{ required: true, message: "Please select section" }]}
      >
        <Select>
          <Option value="Section A">Section A</Option>
          <Option value="Section B">Section B</Option>
        </Select>
      </Form.Item>

      {/* Question */}
      <Form.Item
        name="question"
        label="Question"
        rules={[{ required: true, message: "Please enter the question" }]}
      >
        <Input.TextArea rows={3} />
      </Form.Item>

      {/* Options */}
      <Form.List name="options">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => (
              <Form.Item
                key={key}
                label={`Option ${name + 1}`}
                required
              >
                <Form.Item
                  name={name}
                  noStyle
                  rules={[{ required: true, message: "Option is required" }]}
                >
                  <Input style={{ width: "85%" }} />
                </Form.Item>
                <Button
                  type="link"
                  danger
                  onClick={() => remove(name)}
                >
                  Remove
                </Button>
              </Form.Item>
            ))}
            <Button type="dashed" onClick={() => add()} block>
              + Add Option
            </Button>
          </>
        )}
      </Form.List>

      {/* Correct Answer */}
      <Form.Item
        name="correctAnswer"
        label="Correct Answer"
        rules={[{ required: true, message: "Please select correct answer" }]}
      >
        <Select placeholder="Correct option">
          <Option value={0}>Option 1</Option>
          <Option value={1}>Option 2</Option>
          <Option value={2}>Option 3</Option>
          <Option value={3}>Option 4</Option>
        </Select>
      </Form.Item>

      {/* Explanation */}
      <Form.Item name="explanation" label="Explanation">
        <Input.TextArea rows={3} />
      </Form.Item>

      {/* Topics */}
      <Form.Item name="topics" label="Topics">
        <Select mode="tags" placeholder="e.g. Numbers, Algebra">
          <Option value="Numbers">Numbers</Option>
          <Option value="Algebra">Algebra</Option>
          <Option value="Geometry">Geometry</Option>
        </Select>
      </Form.Item>

      {/* Submit */}
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default QuestionForm;
